import React, { useEffect } from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import { theme } from '../../constants/theme'

import { H3 } from './Typography'

export const Modal = ({
  children, onCloseRequest, titleTrad, title,
}) => {
  useEffect(() => {
    const escapePressed = (e) => {
      if (e.keyCode === 27) { // escape
        onCloseRequest()
      }
    }
    window.addEventListener('keydown', escapePressed)

    return () => window.removeEventListener('keydown', escapePressed)
  }, [onCloseRequest])

  const finalOnClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    onCloseRequest()
  }

  return (
    <ModalWrapper onClick={finalOnClick}>
      <BodyWrapper onClick={(e) => e.stopPropagation()}>
        <TitleSection>
          {title || <H3 tradId={titleTrad} />}
          <CloseButton icon={faTimes} onClick={finalOnClick} />

        </TitleSection>
        <ModalBody>
          {children}
        </ModalBody>
      </BodyWrapper>
    </ModalWrapper>
  )
}

const ModalBody = styled.div`
  padding: 10px;
`

const TitleSection = styled.div`
  padding: 10px;
  padding-right: 30px;
`

const CloseButton = styled(FontAwesomeIcon)`
  color: ${theme.colors.BLACK};
  cursor: pointer;
  position: absolute;
  top: 11px;
  right: 10px;
`

const ModalWrapper = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
`

const BodyWrapper = styled.div`
  background: ${theme.colors.white};
  position: relative;
  border: 1px solid ${theme.colors.blueCommon};
  border-radius: 10px;
  padding: 15px;
  width: 70%;
  @media (max-width: 500px) {
    width: 90%;
  }
`
